/**
 * @flow
 * @relayHash 855a31ce576890c8ab14e02d2e06be91
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POStatus = "APPROVED" | "CANCELLED" | "PARTIALLY_RECEIVED" | "PENDING_APPROVAL" | "RECEIVED" | "REJECTED" | "SENT";
export type UpdatePurchaseOrderStatusInput = {|
  id: string,
  status: POStatus,
|};
export type UpdatePurchaseOrderStatusMutationVariables = {|
  input: UpdatePurchaseOrderStatusInput
|};
export type UpdatePurchaseOrderStatusMutationResponse = {|
  +updatePurchaseOrderStatus: {|
    +purchaseOrder: {|
      +id: string,
      +poNumber: string,
      +status: POStatus,
      +receivedAt: ?any,
      +approvedBy: ?{|
        +id: string,
        +firstName: string,
        +lastName: string,
      |},
      +approvedAt: ?any,
      +updatedAt: any,
    |}
  |}
|};
export type UpdatePurchaseOrderStatusMutation = {|
  variables: UpdatePurchaseOrderStatusMutationVariables,
  response: UpdatePurchaseOrderStatusMutationResponse,
|};
*/


/*
mutation UpdatePurchaseOrderStatusMutation(
  $input: UpdatePurchaseOrderStatusInput!
) {
  updatePurchaseOrderStatus(input: $input) {
    purchaseOrder {
      id
      poNumber
      status
      receivedAt
      approvedBy {
        id
        firstName
        lastName
      }
      approvedAt
      updatedAt
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdatePurchaseOrderStatusInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updatePurchaseOrderStatus",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdatePurchaseOrderStatusPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "purchaseOrder",
        "storageKey": null,
        "args": null,
        "concreteType": "PurchaseOrder",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "poNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "receivedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "approvedBy",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "approvedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "updatedAt",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdatePurchaseOrderStatusMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdatePurchaseOrderStatusMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdatePurchaseOrderStatusMutation",
    "id": null,
    "text": "mutation UpdatePurchaseOrderStatusMutation(\n  $input: UpdatePurchaseOrderStatusInput!\n) {\n  updatePurchaseOrderStatus(input: $input) {\n    purchaseOrder {\n      id\n      poNumber\n      status\n      receivedAt\n      approvedBy {\n        id\n        firstName\n        lastName\n      }\n      approvedAt\n      updatedAt\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '64604907e79f7c7f66f937070c0db418';
module.exports = node;
